import { Calendar } from "lucide-react";
import type { Card, CardAction } from "../../types/chat";

interface Props {
  card: Card;
  onAction: (action: CardAction) => void;
}

export function EventPreviewCard({ card, onAction }: Props) {
  const events = (card.data.events as Array<Record<string, string>>) ?? [];

  return (
    <div className="rounded-lg border bg-card p-3" role="region" aria-label="Calendar events">
      <div className="flex flex-col gap-2">
        {events.slice(0, 5).map((event, i) => (
          <div key={i} className="flex items-start gap-2 text-sm">
            <Calendar className="size-4 text-muted-foreground shrink-0 mt-0.5" />
            <div>
              <span className="font-medium">{event.title ?? "Untitled"}</span>
              {event.start && (
                <p className="text-xs text-muted-foreground">{event.start}{event.end ? ` — ${event.end}` : ""}</p>
              )}
            </div>
          </div>
        ))}
      </div>
      {card.actions?.map((action) => (
        <button key={action.id} onClick={() => onAction(action)} className="mt-2 text-xs text-primary hover:underline">
          {action.label}
        </button>
      ))}
    </div>
  );
}
